import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Button} from "reactstrap";
import AppStore from "../../../stores/appStore";
import orderDeliveryService from "../../../services/orderDeliveryService";
import FlashStore from "../../../stores/flashStore";
import {translate} from "../../../utils/utils";

const ConfirmCopyOrderDeliveryGroup = ({ id, getLink }) => {
    const onClick=()=>{
        AppStore.setIsPreloaderShow(true);
        orderDeliveryService.copy(id).then(res=>{
            AppStore.setIsPreloaderShow(false);
            if(res.code === 200){
                location.href = `${getLink()}/${res.data.id}`;
            }else{
                FlashStore.errorNow(translate("service.serverError"), true)
            }
        })
    }

    const prepareTranslate = ()=>{
        let msg = translate({id:"orderDelivery.confirmCopyOrderDeliveryGroup"});
        return msg.replace("{id}", id)
    }

    return (
        <div className={"p-2"}>
            <div>{prepareTranslate()}</div>
            <div className={"d-flex mt-3"}>
                <Button color={"primary"} onClick={onClick}><FormattedMessage id={"deliveryOrders.orderBlock.orderActions.copyOrderDeliveryRequestGroup"}/></Button>
                <Button className={"ml-3"} onClick={() => AppStore.hideNotificationModal()}><FormattedMessage id={"crudForm.button.cancel"}/></Button>
            </div>
        </div>
    );
};

ConfirmCopyOrderDeliveryGroup.propTypes = {

};

export default ConfirmCopyOrderDeliveryGroup;